import { AxiosResponse } from 'axios';
import axiosInstance from '../../services/axios/axios';
import { then, catchAxiosError } from '../../services/axios/_utility';
/**
 * Asynchronously retrieves outage message.
 * @param {Number} id end-user unique identifier.
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<string>>} outage message or empty string if none.
 */
export const getOutageMessage = async (dispatch = null) => {
	try {
		return axiosInstance
			.get(`api/IMS/OutageMessage`)
			.then(response => then(response, payload => payload, dispatch));
	} catch (e) {
		throw catchAxiosError(e);
	}
};
